(function() {
  if (window.askAnExpertContextBound) return;
  window.askAnExpertContextBound = true;

  var getCurrentPageUrl = function() {
    var url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    url.hash = '';
    return url.toString();
  };

  var openDrawer = function(popup) {
    if (!popup) return;
    if (typeof popup.open === 'function') {
      popup.open();
    } else {
      popup.setAttribute('open', 'true');
      popup.classList.add('active', 'open');
    }
  };

  document.addEventListener('input', function(event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-phone-mask]')) return;

    var digits = input.value.replace(/\D/g, '').slice(0, 10);
    var formatted = '';
    if (digits.length) formatted = '(' + digits.slice(0, 3);
    if (digits.length >= 3) formatted += ')';
    if (digits.length > 3) formatted += ' ' + digits.slice(3, 6);
    if (digits.length > 6) formatted += '-' + digits.slice(6);
    input.value = formatted;
  });

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (!form.closest || !form.closest('[data-contact-form-type="ask-an-expert"]')) return;

    var drawer = form.closest('side-drawer');
    if (drawer && drawer.id) {
      try {
        sessionStorage.setItem('ask-expert-drawer', drawer.id);
      } catch (error) {}
    }

    var productLink = form.querySelector('[data-expert-product-link]');
    if (productLink && window.location.pathname.endsWith(productLink.dataset.productUrl)) {
      productLink.value = getCurrentPageUrl();
    }

    var pageLink = form.querySelector('[data-expert-page-link]');
    if (pageLink) {
      pageLink.value = getCurrentPageUrl();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    var storedId = null;
    try {
      storedId = sessionStorage.getItem('ask-expert-drawer');
      sessionStorage.removeItem('ask-expert-drawer');
    } catch (error) {}

    document.querySelectorAll('[data-contact-form-type="ask-an-expert"]').forEach(function(wrapper) {
      var submit = wrapper.querySelector('button[type="submit"]');
      if (submit) {
        var hasEmail = !!wrapper.querySelector('[data-field-name="email"]');
        submit.disabled = !hasEmail;
        submit.setAttribute('aria-disabled', (!hasEmail).toString());
        wrapper.classList.toggle('ask-an-expert--disabled', !hasEmail);
      }

      if (!wrapper.querySelector('.inquiry-sheet__success')) return;

      var popup = wrapper.closest('side-drawer');
      if (!popup || popup.id !== storedId) return;
      openDrawer(popup);
    });

    if (!window.location.search.includes('contact_posted')) return;

    var url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  });
})();
